// =============================================================================
// Normascan — Plateforme d'analyse normative par IA
// Copyright (c) 2026-2027 Evalens SAS — Tous droits réservés
// Marque Normascan déposée INPI n°5242986 (classes 9 et 42)
// Site : https://app.normascan.fr
// =============================================================================
//
// Libellés PROPRES au module amiante (chantier T2, 29/09/2026).
//
// Chaque module de norme a son fichier de libellés dans `modules/<norme>/`, et
// son catalogue figé dans `tests/normes/<norme>/i18n_catalogue.json` : deux
// branches de module n'ajoutent donc jamais leurs clés au même fichier — plus
// de conflit à chaque fusion.
//
// ⚠️ Les libellés amiante historiques (prélèvements, ZPSO…) sont encore dans
// `locales/` : les déplacer relève de la séparation complète du pipeline, après
// le pilote DPE. Ici, seulement ce qui DÉSIGNE la norme.
//
// Convention : le nom affiché d'une norme est la clé `norme_<code>`.

const amiante = {
  fr: {
    norme_amiante:                     'Amiante',
  },

  en: {
    norme_amiante:                     'Asbestos',
  },
};

export default amiante;
